import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components/macro';

const TextStyled = styled('p')<any>`
  padding-top: 10px;
  font-weight: 800;
`;

const LinkStyled = styled(Link)<any>`
  text-decoration: underline;
`;

const MoreInfoGlossary = (): JSX.Element => {
  return (
    <TextStyled>
      For more info,&nbsp;
      <LinkStyled to={'/glossary'}>visit our Glossary page</LinkStyled>.
    </TextStyled>
  );
};

export default MoreInfoGlossary;
